import * as lib from 'axios'

const axios = lib.create({ baseURL: process.env.DOMAIN + '/api' })

export default ({ Vue }) => {
  Vue.prototype.$ax = axios
  Vue.axios = axios
}

export { axios }
